<div #emojiPickerContainer class="emoji-picker-container">
  <app-svg-icon
    icon="smile"
    [size]="24"
    [strokeWidth]="2"
    color="var(--color-primary)"
    (click)="togglePicker()"
    style="cursor: pointer"
  ></app-svg-icon>

  <dx-popup
    [(visible)]="pickerVisible"
    [shading]="false"
    [hideOnOutsideClick]="true"
    [showTitle]="false"
    [showCloseButton]="false"
    width="fit-content"
    height="fit-content"
    [wrapperAttr]="{ class: 'gpd-popup' }"
    (onHiding)="isHiding = true"
    (onHidden)="isHiding = false"
    (onShown)="updateSelectedEmoji()"
  >
    <dxo-position
      at="bottom left"
      my="top left"
      [of]="emojiPickerContainer"
      collision="fit"
      [offset]="{ x: 0, y: 8 }"
    >
    </dxo-position>
    <emoji-mart
      #emojiPicker
      (emojiSelect)="addEmoji($event)"
      set="apple"
      [showPreview]="false"
      [darkMode]="false"
      [perLine]="8"
      [i18n]="{
        search: 'Search...',
        categories: { search: 'Search Results', recent: 'Recent' }
      }"
      class="emoji-picker"
    ></emoji-mart>
  </dx-popup>
</div>
